import React, { useState } from "react";
import { IoIosArrowUp } from "react-icons/io";
import InputField from "./InputField";
import InputSelecter from "./InputSelecter";
import PhoneNumberField from "./PhoneNumberField";

const FamilyDetailsForm = ({
  formData,
  handleFormChange,
  handlePhoneNumberChange,
  handleCodeChange,
  handleCountryChange,
  castData,
}) => {
  const [isOpen, setIsOpen] = useState(true);

  const toggleOpen = () => setIsOpen((prev) => !prev);

  // Static required fields
  const requiredFields = [
    "father_name",
    "father_occupation",
    "father_phone_number",
    "father_country_code",
    "parents_native",
  ];

  // Return true if a required field is empty
  const hasStaticError = (fieldName) =>
    requiredFields.includes(fieldName) && !formData[fieldName]?.trim();

  const getStaticErrorMessage = (fieldName) =>
    hasStaticError(fieldName) ? "This field is required" : "";

  return (
    <div className="w-full border-gray-300 my-4">
      {/* Header */}
      <div
        className="flex flex-row items-center justify-between mb-4 cursor-pointer"
        onClick={toggleOpen}
      >
        <h2 className="text-xl font-semibold mb-2 md:mb-0 relative">
          Family Details
          {/* Red dot if any required field empty */}
          {requiredFields.some((key) => hasStaticError(key)) && (
            <span className="absolute -top-1 -right-3 h-3 w-3 bg-red-500 rounded-full"></span>
          )}
        </h2>

        <div className="relative flex-1 mx-6 h-4">
          <div className="absolute top-1/2 w-full border-t border-gray-300 -translate-y-1/2" />
          <span className="absolute left-0 top-1/2 -translate-x-1/2 -translate-y-1/2 h-2 w-2 bg-gray-300 rounded-full" />
          <span className="absolute right-0 top-1/2 translate-x-1/2 -translate-y-1/2 h-2 w-2 bg-gray-300 rounded-full" />
        </div>

        <IoIosArrowUp
          size={24}
          className={`transition-transform duration-300 ${
            isOpen ? "rotate-0" : "rotate-180"
          }`}
        />
      </div>

      {/* Collapsible Section */}
      <div
        className={`overflow-hidden transition-all duration-300 ease-in-out ${
          isOpen ? "max-h-[5000px] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        {/* FATHER */}
        <h3 className="text-lg mb-1">Father</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-2 mb-6 px-1">
          <InputField
            label="Name"
            name="father_name"
            placeholder="Enter Father's Name"
            value={formData.father_name}
            onChange={handleFormChange}
            error={hasStaticError("father_name")}
            errorMessage={getStaticErrorMessage("father_name")}
          />
          <InputField
            label="Occupation"
            name="father_occupation"
            placeholder="Enter Occupation"
            value={formData.father_occupation}
            onChange={handleFormChange}
            error={hasStaticError("father_occupation")}
            errorMessage={getStaticErrorMessage("father_occupation")}
          />
          <div>
            <label className="block text-base font-medium text-gray-700 mb-1">
              Phone Number<span className="text-[14px] text-[#E72848]">*</span>
            </label>
            <PhoneNumberField
              value={formData.father_phone_number}
              setPhoneNumber={(newPhone) =>
                handlePhoneNumberChange("father_phone_number", newPhone)
              }
              disabled={false}
              code={formData.father_country_code}
              setCode={(newCode) =>
                handleCodeChange("father_country_code", newCode)
              }
              error={
                hasStaticError("father_phone_number") ||
                hasStaticError("father_country_code")
              }
              errorMessage={
                getStaticErrorMessage("father_phone_number") ||
                getStaticErrorMessage("father_country_code")
              }
            />
            {(hasStaticError("father_phone_number") ||
              hasStaticError("father_country_code")) && (
              <p className="mt-1 text-sm text-red-600">
                This field is required
              </p>
            )}
          </div>
        </div>

        {/* MOTHER */}
        <h3 className="text-lg mb-1">Mother</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-2 mb-6 px-1">
          <InputField
            label="Name"
            name="mother_name"
            placeholder="Enter Mother's Name"
            value={formData.mother_name}
            onChange={handleFormChange}
          />
          <InputField
            label="Occupation"
            name="mother_occupation"
            placeholder="Enter Occupation"
            value={formData.mother_occupation}
            onChange={handleFormChange}
          />
          <div>
            <label className="block text-base font-medium text-gray-700 mb-1">
              Phone Number
            </label>
            <PhoneNumberField
              value={formData.mother_phone_number}
              setPhoneNumber={(newPhone) =>
                handlePhoneNumberChange("mother_phone_number", newPhone)
              }
              disabled={false}
              code={formData.mother_country_code}
              setCode={(newCode) =>
                handleCodeChange("mother_country_code", newCode)
              }
            />
          </div>
        </div>

        {/* PARENTS NATIVE */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-2 mb-6 px-1">
          <div className="md:col-span-3">
            <InputField
              label="Parents Native"
              name="parents_native"
              placeholder="Your parents native address"
              value={formData.parents_native}
              onChange={handleFormChange}
              error={hasStaticError("parents_native")}
              errorMessage={getStaticErrorMessage("parents_native")}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FamilyDetailsForm;